import { defineStore } from 'pinia'

const useSearchStore = defineStore('search', {
  state: () => ({
    searchValue: {},
  }),

  actions: {
    setSearch(key, value) {
      this.searchValue[key] = value
    },
    clearSearch(key) {
      delete this.searchValue[key]
    },
    clearTabSearch(key) {
      for (const item in this.searchValue) {
        if (Object.hasOwnProperty.call(this.searchValue, item)) {
          if (item.indexOf(key) !== -1) {
            delete this.searchValue[item]
          }
        }
      }
    },
  },
  persist: {
    enabled: false,
  },
})

export default useSearchStore
